import { Col, Row } from "antd";
import CategoryCardSkeleton from "./CategoryCardSkeleton";
import React from "react";

const CategoryChoiceMessageSkeleton = () => {
    return (
        <Row gutter={16}>
            <Col span={12}>
                <CategoryCardSkeleton />
            </Col>
            <Col span={12}>
                <CategoryCardSkeleton />
            </Col>
        </Row>
    )
}

export default CategoryChoiceMessageSkeleton